import React from 'react'
import { View } from 'react-native'
import spacing from '../../styles/spacing'
import { FieldPicker } from './FieldPicker'
import { useEntityTypeResolver } from '../../hooks/useDiscoverEntityEntityType'

export const FieldMapperDropdowns = (props) => {
  const {
    fieldList1,
    fieldList2,
    field1Value,
    field2Value,
    onField1Selected,
    onField2Selected,
    mappedParent
  } = props

  // refactored to stop us running this logic over and over for selected fields
  // that don't need all this complexity
  const resolver = useEntityTypeResolver()

  const entityTypeFieldList2 = props.entityTypeFieldList2
  let childEntityTypeFields = null

  let fieldChosen = entityTypeFieldList2?.fields?.find(
    (f) => f.field_data.property == mappedParent?.destination?.id
  )

  if (fieldChosen?.field_data?.type === 'view-list-inline') {
    const entityTypeNameOfFieldChosen =
      fieldChosen?.field_data?.params?.sourceName

    const entityType = resolver(null, null, entityTypeNameOfFieldChosen)

    // console.log(
    //   'Entity type name of field chosen',
    //   entityTypeNameOfFieldChosen,
    //   entityType
    // )

    childEntityTypeFields = entityType?.fields?.map((f) => {
      return {
        id: fieldChosen?.field_data?.property + '.' + f.field_data?.property,
        title: entityType?.label + '.' + f.field_data?.title
      }
    })
  }

  return (
    <View style={{ flex: 1, flexDirection: 'row' }}>
      <View style={[{ paddingBottom: spacing.m1 }, { flex: 1 }]}>
        <FieldPicker
          fieldList={fieldList1}
          placeholder="Source Field"
          value={'' + field1Value}
          onFieldSelected={(value) => onField1Selected(value)}
        />
      </View>
      <View style={[{ paddingBottom: spacing.m1 }, { flex: 1 }]}>
        <FieldPicker
          placeholder="Target Field"
          fieldList={childEntityTypeFields || fieldList2}
          value={'' + field2Value}
          onFieldSelected={(value) => onField2Selected(value)}
        />
      </View>
    </View>
  )
}
